// AutoMapper
import { AutoMap } from '@nartc/automapper';

// Dto
import { HealthInsuranceDto } from 'app/_mapper/healthinsurance.dto';
import { TravelInsuranceDto } from 'app/_mapper/travelinsurance.dto';

export class PartyDto {
    @AutoMap() concernedPersonType: number;
    @AutoMap() relationship: string;
    @AutoMap() escortType: number;
    @AutoMap() initials: string;
    @AutoMap() firstName: string;
    @AutoMap() lastName: string;
    @AutoMap() maidenName: string;
    @AutoMap() middleName: string;
    @AutoMap() dateOfBirth: string;
    @AutoMap() gender: string;
    @AutoMap() streetName: string;
    @AutoMap() houseNumber: string;
    @AutoMap() houseNumberAddition: string;
    @AutoMap() address2: string;
    @AutoMap() postalCode: string;
    @AutoMap() city: string;
    @AutoMap() countryId: string;
    @AutoMap() phoneNumber: string;
    @AutoMap() phoneNumber2: string;
    @AutoMap() email: string;
    @AutoMap() remarks: string;
    @AutoMap() healthInsurances: HealthInsuranceDto[];
    @AutoMap() travelInsurances: TravelInsuranceDto[];
}